import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { adminMe } from "@/lib/api";

const Ctx = createContext(null);

export function AdminAuthProvider({ children }) {
    const [user, setUser] = useState(undefined); // undefined = loading, null = anon
    const refresh = useCallback(async () => {
        const token = localStorage.getItem("naami_admin_token");
        if (!token) { setUser(null); return; }
        try {
            const u = await adminMe();
            setUser(u);
        } catch {
            localStorage.removeItem("naami_admin_token");
            setUser(null);
        }
    }, []);
    useEffect(() => { refresh(); }, [refresh]);

    const signIn = (token, u) => {
        localStorage.setItem("naami_admin_token", token);
        setUser(u);
    };
    const signOut = () => {
        localStorage.removeItem("naami_admin_token");
        setUser(null);
    };
    return <Ctx.Provider value={{ user, signIn, signOut, refresh }}>{children}</Ctx.Provider>;
}

export const useAdminAuth = () => useContext(Ctx);
